import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformacionesGridComponent } from '../../components/informaciones/informaciones-grid/informaciones-grid.component';

@Component({
  selector: 'app-informaciones',
  standalone: true,
  imports: [CommonModule, InformacionesGridComponent],
  templateUrl: './informaciones.component.html',
  styleUrls: ['./informaciones.component.scss']
})
export class InformacionesComponent {
}
